import { ReactElement } from 'react';
import { createKey } from '@client/common/utils/key/key';
import { useTranslate } from '@client/i18n/hooks';
import { BulkPrice } from '@client/product/components/ProductData/BulkPrices/BulkPrice';
import classNames from 'classnames';
import { Icon, ICON_NAME, ICON_SIZE } from 'b2b-components/theme/components/Icon';
import { Props } from './BulkPrices.types';
import './BulkPrices.scss';

export const BulkPrices = ({
  className,
  discounts,
}: Props): ReactElement | null => {
  const t = useTranslate();
  const rootClassName = classNames('BulkPrices', className);
  const text = {
    title: t('Bulk prices discounts'),
    info: t('*Discount is subtracted in cart.'),
  };

  if (!discounts || discounts.length === 0) {
    return null;
  }

  return (
    <div className={rootClassName}>
      <div className="BulkPrices-TitleContainer">
        <Icon
          name={ICON_NAME.discount}
          className="BulkPrices-IconDiscount"
          size={ICON_SIZE.default}
        />
        <span className="BulkPrices-Title">{text.title}:</span>
      </div>
      {discounts.map(({ fromQuantity, discount }) => (
        <BulkPrice
          key={createKey(fromQuantity, discount)}
          fromQuantity={fromQuantity}
          discount={discount}
        />
      ))}
      <div className="BulkPrice-Info">{text.info}</div>
    </div>
  );
};
